import React, { useState } from 'react'
import { Modal, Box, RadioGroup, Radio, Link, Icon } from '@maui/elements'
import {
  LegacyReportForm,
  LegacyThreatProfileForm,
  ReportForm,
  ThreatProfileForm,
  VulnerabilityForm
} from '../forms'
import { Divider } from '../common/Divider'

const REPORT_DIGEST = 'Report Digest'
const THREAT_PROFILE_DIGEST = 'Threat Profile Digest'
const VULNERABILITY_DIGEST = 'Vulnerability Digest'
const MANDIANT_REPORT = 'MANDIANT_REPORT'
const MANDIANT_VULNERABILITY = 'MANDIANT_VULNERABILITY'

const titles = {
  MANDIANT_REPORT: 'Report Digest',
  MANDIANT_VULNERABILITY: 'Vulnerability Digest',
  THREAT_PROFILE_DIGEST: 'Threat Profile Digest',
  'Report Digest': 'Report Digest',
  'Threat Profile Digest': 'Threat Profile Digest',
}

export const ChooseForm = ({ value, formProps, setValue, hasTpAccess, hasDigestNotificationsUi }) => {
  if (!hasTpAccess || formProps.editData) {
    return <Box textStyle="bodySmall" color="colorTextMain" fontWeight="fontWeightBold">{titles[value]}</Box>
  }

  const radioValue = hasDigestNotificationsUi ? MANDIANT_REPORT : REPORT_DIGEST

  return (
    <RadioGroup
      onChange={e => setValue(e.target.value)}
      value={value}
    >
      <Radio value={radioValue} data-testid="report-radio-input">
        <Box width="150px">{REPORT_DIGEST}</Box>
        <Box textStyle="bodySmall" color="colorTextMain" ml="spaceGapMedium">Sign up for our email digest to get the latest news analysis and reports in your inbox</Box>
      </Radio>

      <Radio value={THREAT_PROFILE_DIGEST} disabled={!formProps?.threatProfiles?.length} data-testid="tp-radio-input">
        {
          formProps?.threatProfiles?.length
            ? <>
              <Box width="150px">{THREAT_PROFILE_DIGEST}</Box>
              <Box textStyle="bodySmall" color="colorTextMain" ml="spaceGapMedium">Sign up for our threat profile digest to get the latest, personalized threat updates in your inbox</Box>
          </>
            : <>
              <Box width="150px">{THREAT_PROFILE_DIGEST}</Box>
              <Box textStyle="bodySmall" color="colorTextMain" ml="spaceGapMedium"> You must have at least one threat profile to sign up for this digest.</Box>
              <Link href='/threat-profiles/create' alt="Click to create a new threat profile" target="_blank" rel="noopener noreferrer">
                Create a profile
                <Icon name="externalLink" verticalAlign="top" mx="spaceGapMedium" />
              </Link>
            </>
        }
      </Radio>
      {hasDigestNotificationsUi && (
        <Radio value={MANDIANT_VULNERABILITY} data-testid="vuln-radio-input">
          <Box width="150px">{VULNERABILITY_DIGEST}</Box>
          <Box textStyle="bodySmall" color="colorTextMain" ml="spaceGapMedium">Sign up to get the latest vulnerability updates in your inbox</Box>
        </Radio>
      )}
    </RadioGroup>
  )
}

export const Component = ({ value, formProps, onClose, hasDigestNotificationsUi }) => {
  const DefaultFormComponent = hasDigestNotificationsUi ? ReportForm : LegacyReportForm
  const ThreatProfileComponent = hasDigestNotificationsUi ? ThreatProfileForm : LegacyThreatProfileForm

  switch (value) {
    case REPORT_DIGEST:
      return <LegacyReportForm {...formProps} onClose={onClose} />
    case THREAT_PROFILE_DIGEST:
    case 'THREAT_PROFILE_DIGEST':
      return <ThreatProfileComponent {...formProps} onClose={onClose} />
    case 'MANDIANT_REPORT':
      return <ReportForm {...formProps} onClose={onClose} />
    case 'MANDIANT_VULNERABILITY':
      return <VulnerabilityForm {...formProps} onClose={onClose} />
    default:
      return <DefaultFormComponent {...formProps} onClose={onClose} />
  }
}

function EmailDigestNotificationModal(props) {
  const { isOpen, onClose, status, type, hasTpAccess, hasDigestNotificationsUi, ...formProps } = props
  const defaultReport = hasDigestNotificationsUi ? MANDIANT_REPORT : REPORT_DIGEST
  const [value, setValue] = useState(formProps?.formType || formProps?.editData?.type || defaultReport)

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} onClose={onClose} status={status}>
      <Modal.Header onClose={onClose}>
        <Modal.Title>{formProps.editData ? 'Edit' : 'Add'} Email Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <ChooseForm value={value} formProps={formProps} setValue={setValue} hasTpAccess={hasTpAccess} hasDigestNotificationsUi={hasDigestNotificationsUi} />
        <Divider my="spaceGapXLarge" />
        <Component value={value} formProps={formProps} onClose={onClose} hasDigestNotificationsUi={hasDigestNotificationsUi} />
      </Modal.Body>
    </Modal>
  )
}

export default EmailDigestNotificationModal
